import UIComponent from "../ui/component.js";
import api from "../api/index.js";
import { getPriceWithSymbol } from "../utils/prulization.js";
import goals from "../utils/goals.js";

export class OfferCheckout extends UIComponent {
    monthlyType = "monthly";
    yearlyType = "yearly";
    GOALS_BY_CHECKOUT_TYPE = {
        subscription: "PaymentSubscription",
        payperminute: "PaymentMinutes",
    };

    /**
     * Возвращает текущий URL с обновлёнными query-параметрами,
     * не затирая остальные.
     *
     * Поддерживаем как минимум:
     * - variant: monthly|yearly
     * - recurrent: true|false
     */
    getUpdatedUrl(params = {}) {
        const url = new URL(window.location.href);
        const search = url.searchParams;

        if (Object.prototype.hasOwnProperty.call(params, "variant")) {
            const value = params.variant;
            if (value === null || value === undefined || value === "") {
                search.delete("variant");
            } else {
                search.set("variant", value);
            }
        }

        if (Object.prototype.hasOwnProperty.call(params, "recurrent")) {
            const value = params.recurrent;
            if (value === null || value === undefined || value === "") {
                search.delete("recurrent");
            } else {
                search.set("recurrent", value);
            }
        }

        url.search = search.toString();
        return url.toString();
    }

    get subscriptionUrl() {
        return `/api/subscriptions/${this.type_rates}`;
    }

    init() {
        if (this.GOALS_BY_CHECKOUT_TYPE[this.checkout_type]) {
            goals.reach(this.GOALS_BY_CHECKOUT_TYPE[this.checkout_type]);
        }

        console.log(this.type_rates);
        console.log("Subscription URL:", this.subscriptionUrl);

        if (this.checkout_type !== "subscription") {
            return;
        }

        if (this.priceSwitcher) {
            this.priceSwitcher.element.checked =
                this.offer_type === this.yearlyType;
            this.priceSwitcher.on(
                "change",
                this.handleSubscriptionChange.bind(this)
            );

            if (!this.priceSwitcher.element.checked) {
                this.subscriptionType = this.monthlyType;
                this.price = null;
                this.checkout_title = this.checkout_title_monthly;
            } else {
                this.checkout_title = this.checkout_title_yearly;
            }
        }

        if (this.subscriptionSettings) {
            if (!this.has_recurrent) {
                this.subscriptionSettings.hide();
            }

            if (this.in_future == 1) {
                this.subscriptionSettings.switch.element.disabled = true;
            }

            this.subscriptionSettings.switch.element.checked = this.recurrent === "true" || this.recurrent == "1";
            this.subscriptionSettings.on(
                "change",
                this.handleRecurrentChange.bind(this)
            );

            this.updateSettingsContent()
        }
    }

    async handleSubscriptionChange(e) {
        const isAnnual = e.target.checked;
        this.subscriptionType = isAnnual ? this.yearlyType : this.monthlyType;
        this.checkout_title = isAnnual
            ? this.checkout_title_yearly
            : this.checkout_title_monthly;

        if (!isAnnual) {
            this.price = null;
        }
        try {
            const url = isAnnual
                ? this.getUpdatedUrl({ variant: this.yearlyType })
                : this.getUpdatedUrl({ variant: this.monthlyType });

            window.location.href = url;
            // const response = await api.get(url);
            // if (response) {
            //     await this.updatePrices(response);
            // }
        } catch (error) {
            console.error("Failed to load subscription data:", error);
            this.errorBag?.show("Failed to load subscription options");
        }
    }

    async handleRecurrentChange(e) {
        const isRecurrent = e.target.checked;

        try {
            const url = isRecurrent
                ? this.getUpdatedUrl({ recurrent: "true" })
                : this.getUpdatedUrl({ recurrent: "false" });

            window.location.href = url;
            // const response = await api.get(url);
            // if (response) {
            //     await this.updatePrices(response);
            // }
        } catch (error) {
            console.error("Failed to load subscription data:", error);
            this.errorBag?.show("Failed to load subscription options");
        }
    }

    updateSettingsContent() {
        console.log(this.subscriptionSettings)
        if (!this.subscriptionSettings.description) return;

        const isChecked = this.subscriptionSettings?.switch?.element?.checked || false;

        if (isChecked) {
            this.subscriptionSettings.description.element.textContent = this.subscriptionSettings.text_on;
        } else {
            this.subscriptionSettings.description.element.textContent =  this.subscriptionSettings.text_off;
        }
    }

    // async updatePrices(priceData) {
    //     console.log(priceData);
    //     this.total_price.element.textContent = `${priceData.subscription.amount_formatted}`;
    //     this.price = this.subscriptionType !== this.monthlyType
    //             ? `${
    //                   priceData.subscription.variants?.[this.subscriptionType]
    //                       .amount_formatted_with_period
    //               }`
    //             : null;

    //     await api
    //         .post(
    //             decodeURIComponent(this.offer_url) +
    //                 "&variant=" +
    //                 this.subscriptionType,
    //             { headers: { "Content-Type": "application/json" } }
    //         )
    //         .then((response) => {
    //             if (this.payanyway) {
    //                 this.payanyway.iframe.src = response.paymentData.url;
    //             }
    //             if (this.robokassa) {
    //                 this.robokassa.iframe.src = response.paymentData.url;
    //             }
    //             if (this.stripe) {
    //                 this.stripe.paymentData = response.paymentData;
    //             }
    //             if (this.paypal) {
    //                 this.paypal.paymentData = response.paymentData;
    //             }
    //         });
    // }
}
